import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("BILLING_DEFINITIONS");
const CRUD_ACTION_HANDLERS = getActionHandler("BILLING_DEFINITIONS");

export default function billingDefinitions(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
